const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconUpdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.73 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#2e3a47;stroke-miterlimit:10;}.cls-2{fill:#fefefe;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flujo_de_caja",
    "data-name": "Flujo de caja"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.25,6.3A9.25,9.25,0,0,1,20.08,9.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.49,13A9.25,9.25,0,0,1,2.77,14.28,9.06,9.06,0,0,1,2.18,13a9.3,9.3,0,0,1-.59-3.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.67 8.52 2.07 9.21 2.47 9.91 1.67 9.91 0.87 9.91 1.27 9.21 1.67 8.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.06 10.41 19.66 9.71 19.26 9.02 20.06 9.02 20.87 9.02 20.46 9.71 20.06 10.41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpdate);
export default __webpack_public_path__ + "static/media/icon_update.915bd7bac19cee55b05db4944e7a9519.svg";
export { ForwardRef as ReactComponent };